<template>
  <div>
    <vuex-breadcrumb></vuex-breadcrumb>
    <brand-create
      :ams_template="ams_template"
      :reroute="reroute"
    ></brand-create>
  </div>
</template>

<script>
import VuexBreadcrumb from './VuexBreadcrumb.vue'
import BrandCreate from './BrandCreate.vue'

export default {
  components: {
    VuexBreadcrumb,
    BrandCreate
  },
  props: {
    reroute: {
      Type: Boolean,
      default: true
    },
    ams_template: {
      Type: Object
    }
  }
}
</script>